import { useAuth } from '../contexts/AuthContext';
import { useMyWeek } from '../lib/data';
import { formatDuration } from '../lib/format-duration';
import { AKHARA_BG, MITTI_BG, sumDays } from '../lib/people-time';

/** The learner's own last 7 days, in the same unit as the Khalifa roster. */
export function ThisWeekView({ akharaMin, mittiMin }: { akharaMin: number; mittiMin: number }) {
  const total = akharaMin + mittiMin;
  return (
    <section
      aria-label="This week"
      className="mt-4 rounded-xl border border-rule bg-paper-0 p-4 dark:border-clay-rule dark:bg-clay-surface"
    >
      <h2 className="text-[11px] font-semibold uppercase tracking-wider text-ink-400">This week</h2>
      {total <= 0 ? (
        <p className="mt-1 text-sm text-ink-500 dark:text-paper-300">Your Mehnat this week shows here.</p>
      ) : (
        <>
          <p className="mt-1 text-sm text-ink-800 dark:text-paper-100">
            <span className="font-semibold">{formatDuration(total)}</span> of Mehnat in the last 7 days
          </p>
          <p className="mt-0.5 flex flex-wrap items-center gap-x-3 text-xs text-ink-500 dark:text-paper-300">
            <span className="inline-flex items-center gap-1">
              <span className={`h-2.5 w-2.5 rounded-sm ${AKHARA_BG}`} /> Akhara {formatDuration(akharaMin)}
            </span>
            <span className="inline-flex items-center gap-1">
              <span className={`h-2.5 w-2.5 rounded-sm ${MITTI_BG}`} /> Mitti {formatDuration(mittiMin)}
            </span>
          </p>
        </>
      )}
    </section>
  );
}

export default function ThisWeekCard() {
  const { user } = useAuth();
  const { days, ready } = useMyWeek(user?.uid);
  if (!ready) return null;
  const s = sumDays(days);
  return <ThisWeekView akharaMin={s.akharaMin} mittiMin={s.mittiMin} />;
}
